import { useSelector } from 'react-redux';
import { ConnectorAppendixProps } from './Appendix.proptype';
import * as localReportsSelectors from '../../../../../selectors/localReports';

export const Connector = ({ component: Component }: ConnectorAppendixProps) => {
  const selectedAppendixConfigState = useSelector(localReportsSelectors.selectAppendixConfigState);
  return <Component appendixConfigState={selectedAppendixConfigState} />;
};
